export const config_module = {
  base_url: 'https://api-iangels.clawz.org',
  context: 'production',
  domain: 'dev-ixr600zpl0u4omdw.us.auth0.com',
  client_id: 'fJmTcLiCCg81HkKOcN3pzgGs17XAfm39',
  custom_domain: 'https://dev-ixr600zpl0u4omdw.us.auth0.com',
  org_id: 'iangels',
  redirectUrl: 'https://iangels.clawz.org',
  cloudinaryCloudName: 'iangels',
  gtmId: 'GTM-WTBCCDJ',
  marketing_website_base_url: 'https://iangels.clawz.org/',
  auth0_connection: 'Username-Password-Authentication',
  segment_write_key: 'usEclqYCPmfc7h7fHIBew6aa4ssgyKqZ',
  hubspot_portal_id: '25941199',
  hubspot_hublet: 'eu1',
  demo_mode: true
};
